import getChartColor from './get-chart-color';

/**
 * Given an array of configuration objects, each of which contains a label and
 * an array of filtered data points, generates a chart data object suitable for
 * use with chart.js.
 * @param {Array} series - An array of objects, each containing a label and data array.
 * @param {number} tab - The active tab.
 * @returns {object} A data object suitable for use with chart.js.
 */
const formatChartData = (series, tab) => series.reduce((acc, item, index) => {
  // Populate labels, if necessary.
  if (acc.labels.length === 0) {
    acc.labels = item.data.map(({ year }) => year);
  }

  // Build a dataset for this item.
  const color = getChartColor(index);
  acc.datasets.push({
    label: item.label,
    data: item.data.map(({ value }) => value),
    fill: tab >= 2,
    backgroundColor: color,
    borderColor: color,
  });

  // Ensure datasets are in order from smallest to largest to support the stacked area chart.
  if (tab >= 2) {
    acc.datasets.sort((a, b) => a.data.reduce((accA, itemA) => (itemA > accA ? itemA : accA), 0)
      - b.data.reduce((accB, itemB) => (itemB > accB ? itemB : accB), 0));
  }

  return acc;
}, {
  datasets: [],
  labels: [],
});

export default formatChartData;
